//  import lodash from 'lodash'
import Helper from '@/Helper'
export default {
  setData (state, payload) {
    state.organization = payload
  },
  addRoot (state, payload) {
    state.organization.push(payload)
  },
  addOrganizationChidrent (state, payload) {
    var data = []
    state.organization.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.push(payload)
    state.organization = Helper.getNestedChildren(data, 0)
  },
  updateOrganization (state, payload) {
    var data = []
    var items = []
    state.organization.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
        element = payload
      }
      items.push(element)
    })
    state.organization = Helper.getNestedChildren(items, 0)
  },
  getTrashOrganization (state, payload) {
    state.trash.organizations = payload.data
    state.trash.last_page = payload.meta.last_page
    state.trash.total = payload.meta.total
  },
  destroyOrganization (state, payload) {
    var data = []
    var items = []
    state.organization.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
      } else {
        items.push(element)
      }
    })
    state.organization = Helper.getNestedChildren(items, 0)
  },
  restore (state, payload) {
    state.trash.result = payload
  },
  openEdit (state, payload) {
    state.open_edit = true
    state.open_create_children = false
    state.open_view = false
    state.open_user = false
  },
  closeEdit (state, payload) {
    state.open_edit = false
    state.open_view = true
    state.open_create_children = false
    state.open_user = false
  },
  openCreateChildren (state, payload) {
    state.open_create_children = true
    state.open_edit = false
    state.open_view = false
    state.open_user = false
  },
  closeCreateChildren (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = true
    state.open_user = false
  },
  openView (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = true
    state.open_user = false
  },
  closeView (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = false
    state.open_user = false
  },
  openUser (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = false
    state.open_user = true
  },
  closeUser (state, payload) {
    state.open_create_children = false
    state.open_edit = false
    state.open_view = true
    state.open_user = false
  }
}



// WEBPACK FOOTER //
// ./src/store/module/organization/mutations.js